import React, { useEffect, useState } from 'react'
import './style.css'
import logo from '../../image/logo.png'
import logoBlack from '../../image/logos-08Black.svg'
import vector from '../../image/Vector.svg'
import vectorBlack from '../../image/VectorBlack.svg'
import u_sup from '../../image/U_superior 1.svg'
import u_supBlack from '../../image/U_superior.png'
import Contor from '../../image/Pattern Urbam Contorno BRANCO-02.svg'
import Contorn from '../../image/Pattern Urbam Contorno BRANCO-03.svg'
import ContorBlack from '../../image/patter2.png'
import ContornBlack from '../../image/patter3.png'
import Button from 'react-bootstrap/Button'
import MuiAlert from '@mui/material/Alert'
import Snackbar from '@mui/material/Snackbar'
import api from '../../services/api'
import {
  setContrato,
  setContratos,
  setEmailLogin,
  setPasswordLogin,
  setToken,
  isAuthenticated,
  getEmailLogin,
  getPasswordLogin,
  setUserId,
  setUsuarioCargoId,
  setUsuarioSetorId,
  setUsername,
  setFirstLogin,
  logout
} from '../../services/auth'
import Loading from '../../components/Loading'
import { MuiOtpInput } from 'mui-one-time-password-input'
import FormControl from '@mui/material/FormControl'
import OutlinedInput from '@mui/material/OutlinedInput'
import InputLabel from '@mui/material/InputLabel'
import InputAdornment from '@mui/material/InputAdornment'
import IconButton from '@mui/material/IconButton'
import Visibility from '@mui/icons-material/Visibility'
import VisibilityOff from '@mui/icons-material/VisibilityOff'
import { useTheme } from '@mui/material'
import nest from '../../services/nest'
import Aviso from '../../components/Aviso'

function Login({ history }) {
  const theme = useTheme();
  const [showPassword, setShowPassword] = useState(false)
  const handleClickShowPassword = () => setShowPassword(show => !show)
  const handleMouseDownPassword = event => {
    event.preventDefault()
  }
  const [showPassword2, setShowPassword2] = useState(false)
  const handleClickShowPassword2 = () => setShowPassword2(show => !show)
  const handleMouseDownPassword2 = event => {
    event.preventDefault()
  }
  const [showPassword3, setShowPassword3] = useState(false)
  const handleClickShowPassword3 = () => setShowPassword3(show => !show)
  const handleMouseDownPassword3 = event => {
    event.preventDefault()
  }
  const [otp, setOtp] = React.useState('')
  const handleChange = newValue => {
    setOtp(newValue)
  }
  const [show, setShow] = useState(false)
  const [valid, setValid] = useState(false)
  const [senha, setSenha] = useState(false)
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  useEffect(() => {
    let item = document.querySelector('.fundo')
    let item3 = document.querySelector('.patter')
    let item4 = document.querySelector('.patter2')
    let item2 = document.querySelector('.caixa_login')
    // play normal
    item2.addEventListener('mouseover', () => {
      item.classList.add('active')
      item3.classList.add('active')
      item4.classList.add('active')
    })
    let email = getEmailLogin();
    setEmail(email);
    let password = getPasswordLogin();
    setPassword(password)
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  useEffect(() => {
    if(isAuthenticated()){
      if(email !== ''){
        login()
      }
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [email])
  const [loading, setLoading] = useState(false)
  const [emailValidError, setEmailValidError] = useState('')
  const [confirmPassword, setConfirmPassword] = useState('')
  const login = () => {
    if (email === '') {
      setAlerta({
        status: true,
        msg: 'Preencha o e-mail!',
        type: 'error'
      })
    } else {
      if (password === '') {
        setAlerta({
          status: true,
          msg: 'Preencha a senha!',
          type: 'error'
        })
      } else {
        if (handleValidEmail()) {
          setLoading(true)
          nest
            .post(`/cliente/cliente-logins/login`, {
              email: email,
              senha: password
            })
            .then(function (response) {
              setLoading(false)
              if (response.data != null) {
                const {email, id, cargo, setor, nome, status} = response.data;
                if (status === 200) {
                  const { token } = response.data
                  setFirstLogin('2')
                  setEmailLogin(email)
                  setPasswordLogin(password)
                  setToken(token)
                  setUserId(id)
                  setUsuarioCargoId(cargo);
                  setUsuarioSetorId(setor);
                  setUsername(nome);
                  getContracts()
                } else {
                  setAlerta({
                    status: true,
                    msg: 'Não foi possível realizar o login!',
                    type: 'error'
                  })
                }
              } else {
              }
            })
            .catch(function (error) {
              setLoading(false)
              setAlerta({
                status: true,
                msg: 'Não foi possível realizar o login!',
                type: 'error'
              })
            })
        }
      }
    }
  }
  const [alerta, setAlerta] = useState({
    status: false,
    msg: ''
  })
  const Alert = React.forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />
  })
  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return
    }
    setAlerta({
      status: false,
      msg: ''
    })
  }
  const handleValidEmail = () => {
    setEmail(email.trim())
    let reg = /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i
    if (email !== '' && email != null) {
      if (reg.test(email) === false) {
        setEmailValidError('Digite um e-mail valido!')
        return false
      } else if (reg.test(email) === true) {
        setEmailValidError('')
        return true
      }
    }
  }
  const handleChangeEmail = event => {
    setEmail(event.target.value)
  }
  const handleChangeSenha = event => {
    setPassword(event.target.value)
  }
  const getContracts = async () => {
    setLoading(true)
    nest
      .get(`/clientes/PorUsuario`)
        .then(function (response) {
        setLoading(false)
        let dataTemp = response.data
        if (dataTemp != null) {
          if (!dataTemp.status) {
            setContratos(dataTemp)
            if (dataTemp.length === 1) {
              let id = dataTemp[0].id
              setContrato(id.toString())
            }
            history.push('home')
          } else {
            if (dataTemp.status === 401) {
              //gerar novo token
            }
          }
        }
      })
      .catch(function (error) {
        setAlerta({
          status: true,
          msg: 'Não foi possível encontrar seus contratos!',
          type: 'error'
        })
        logout()
        setLoading(false)
        console.log(error)
      })
  }
  const validaEmail = () => {
    if (email === '') {
      setAlerta({
        status: true,
        msg: 'Preencha o e-mail!',
        type: 'error'
      })
    } else {
      if (handleValidEmail()) {
        setLoading(true)
        api
          .post(`/clients/email`, {
            email
          })
          .then(function (response) {
            setLoading(false)
            if (response.data != null) {
              var { status } = response.data
              if (status === true) {
                setValid(true)
              } else {
                var { message } = response.data
                setAlerta({
                  status: true,
                  msg: message,
                  type: 'error'
                })
              }
            }
          })
          .catch(function (error) {
            setLoading(false)
            console.log(error)
            setAlerta({
              status: true,
              msg: 'Ocorreu um erro!',
              type: 'error'
            })
          })
      }
    }
  }
  const codeVer = () => {
    let ver = true
    if (otp == null || otp === '') {
      setAlerta({
        status: true,
        msg: 'Preencha o código!',
        type: 'error'
      })
      ver = false
      return false
    }
    if (otp.length < 6) {
      setAlerta({
        status: true,
        msg: 'Preencha todo o código!',
        type: 'error'
      })
      ver = false
      return false
    }
    if (ver) {
      setSenha(true)
    }
  }
  const handleChangeConfirmPassword = event => {
    setConfirmPassword(event.target.value)
  }
  const alterar = () => {
    let ver = true
    if (password == null || password === '') {
      setAlerta({
        status: true,
        msg: 'Preencha a nova senha!',
        type: 'error'
      })
      ver = false
      return false
    }
    if (confirmPassword == null || confirmPassword === '') {
      setAlerta({
        status: true,
        msg: 'Preencha a confirmação da nova senha!',
        type: 'error'
      })
      ver = false
      return false
    }
    if (password !== confirmPassword) {
      setAlerta({
        status: true,
        msg: 'A nova senha e a confirmação da senha não são iguais!',
        type: 'error'
      })
      ver = false
      return false
    }
    if (ver) {
      setLoading(true)
      api
        .post(`/clients/altera`, {
          email: email,
          codigo: otp,
          password,
          confirmPassword
        })
        .then(function (response) {
          if (response.data != null) {
            var { status } = response.data
            if (status === true) {
              setAlerta({
                status: true,
                msg: 'Senha alterada com sucesso!',
                type: 'success'
              })
              api
                .post(`/clients/login`, {
                  email: email,
                  password: password
                })
                .then(function (response) {
                  setLoading(false)
                  if (response.data != null) {
                    var { idcliente } = response.data
                    if (idcliente) {
                      var { token } = response.data
                      setEmailLogin(email)
                      setPasswordLogin(password)
                      setToken(token)
                      getContracts()
                    } else {
                      var { message } = response.data
                      setAlerta({
                        status: true,
                        msg: message,
                        type: 'error'
                      })
                      setSenha(false)
                    }
                  }
                })
                .catch(function (error) {
                  setLoading(false)
                  setAlerta({
                    status: true,
                    msg: 'Ocorreu um erro!',
                    type: 'error'
                  })
                  setSenha(false)
                })
            } else {
              setLoading(false)
              var { message } = response.data
              setAlerta({
                status: true,
                msg: message,
                type: 'error'
              })
              setSenha(false)
            }
          } else {
            setAlerta({
              status: true,
              msg: 'Ocorreu um erro!',
              type: 'error'
            })
            setSenha(false)
          }
        })
        .catch(function (error) {
          setLoading(false)
          setAlerta({
            status: true,
            msg: 'Ocorreu um erro!',
            type: 'error'
          })
          setSenha(false)
        })
    }
  }
  return (
    <div className="App">
      <Loading open={loading} />
      {/* <Aviso /> */}
      <img
        src={theme !== 'dark' ? u_sup : u_supBlack}
        className="u_sup"
        alt="logo"
      />
      <img
        className="patter"
        src={theme !== 'dark' ? Contor: ContorBlack}
        style={{
          width: 280,
          position: 'absolute',
          top: -2,
          left: 0,
          opacity: 0
        }}
        alt="logo"
      />
      <img
        className="patter2"
        src={theme !== 'dark' ? Contorn: ContornBlack}
        style={{
          width: 280,
          position: 'absolute',
          bottom: 0,
          left: 0,
          opacity: 0
        }}
        alt="logo"
      />
      <div className="App-header">
        <div className="Container row">
          <div
            className="col-sm-12 col-md-12 col-xs-12 col-12 col-lg-6 col-xl-6 bxlogo"
          >
            <img height={100} src={theme !== 'dark' ? logo : logoBlack} className="logo" alt="logo" />
          </div>
          <div className="col-sm-12 col-md-12 col-xs-12 col-12 col-lg-6 col-xl-6 bxlogin"
          >
            <div
              className="fundo"
              style={{
                backgroundImage: theme !== 'dark' ? `url(${vector})` : `url(${vectorBlack})`,
              }}
            ></div>

            {!show ? (
              <div
                className="caixa_login"
              >
                <h1 className="verificacao">Acesso</h1>
                <p>
                  Insira o seu e-mail e a sua senha para acessar a área do
                  cliente
                </p>
                {emailValidError ? (
                  <div className="helpText">{emailValidError}</div>
                ) : null}
                  <FormControl sx={{ m: 1, width: '100%' }} variant="outlined">
                    <InputLabel>Email</InputLabel>
                    <OutlinedInput
                      label="Email"
                      value={email}
                      type="email"
                      onChange={handleChangeEmail}
                      onBlur={() => handleValidEmail()}
                    />
                  </FormControl>
                  <FormControl sx={{ m: 1, width: '100%' }} variant="outlined">
                    <InputLabel>Password</InputLabel>
                    <OutlinedInput
                      type={showPassword ? 'text' : 'password'}
                      value={password}
                      onChange={handleChangeSenha}
                      onKeyPress={event => {
                        if (event.key === 'Enter') {
                          login();
                        }
                      }}
                      endAdornment={
                        <InputAdornment position="end">
                          <IconButton
                            aria-label="toggle password visibility"
                            onClick={handleClickShowPassword}
                            onMouseDown={handleMouseDownPassword}
                            edge="end"
                          >
                            {showPassword ? <VisibilityOff /> : <Visibility />}
                          </IconButton>
                        </InputAdornment>
                      }
                      label="Password"
                    />
                  </FormControl>
                <p
                  style={{
                    fontSize: 12,
                    cursor: 'pointer',
                    color: 'var(--main-secondy)',
                    textAlign: 'right',
                    marginTop: -8,
                    marginRight: 19,
                    marginLeft: 80
                  }}
                  onClick={() => setShow(true)}
                >
                  Esqueceu a sua senha?
                </p>
                <div>
                  <Button
                    size="lg"
                    active
                    style={{
                      backgroundColor: 'var(--main-bg-D9)',
                      color: 'var(--main-white-color)',
                      border: 'none',
                      padding: 8,
                      fontSize: 16
                    }}
                    className="login3"
                    onClick={() => login()}
                  >
                    Login
                  </Button>
                </div>
                <div>
                  <Button
                    size="sm"
                    style={{
                      backgroundColor: 'var(--main-bg-D9)',
                      border: 'none',
                      color: '#333333'
                    }}
                    onClick={() =>  history.push('solucoes')}
                  >
                    Não sou cliente
                  </Button>
                </div>
              </div>
            ) : !valid ? (
              <div
                className="caixa_login"
              >
                <h1 className="verificacao">
                  Esqueceu a sua senha ?
                </h1>
                <p> Insira seu e-mail para recuperar a senha!</p>
                {emailValidError ? (
                  <div className="helpText">{emailValidError}</div>
                ) : null}
                <FormControl sx={{ m: 1, width: '100%' }} variant="outlined">
                  <InputLabel>Email</InputLabel>
                  <OutlinedInput
                    label="Email"
                    value={email}
                    onChange={handleChangeEmail}
                    onBlur={() => handleValidEmail()}
                  />
                </FormControl>
                <div>
                  <Button
                    style={{
                      backgroundColor: 'var(--main-bg-D9)',
                      border: 'none',
                      color: 'var(--main-white-color)',
                      fontSize: 16,
                      width: '60%',
                      height: 40,
                      textAlign: 'center',
                      marginTop: 20
                    }}
                    onClick={() => validaEmail()}
                  >
                    Validar
                  </Button>
                </div>
                <div>
                  <Button
                    className="voltar"
                    style={{
                      backgroundColor: 'var(--main-bg-D9)',
                      color: '#333333',
                      border: 'none',
                      marginTop: 16,
                      width: '39%'
                    }}
                    onClick={() => setShow(false)}
                  >
                    Voltar
                  </Button>
                </div>
              </div>
            ) : !senha ? (
              <div
                className="caixa_login"
              >
                <h1 className="verificacao" style={{ marginTop: 20 }}>
                  Verificação
                </h1>
                <p>Insira o código de verificação enviado por e-mail!</p>

                <MuiOtpInput value={otp} onChange={handleChange} length={6} />

                <div>
                  <Button
                    style={{
                      backgroundColor: 'var(--main-bg-D9)',
                      border: 'none',
                      color: 'var(--main-white-color)',
                      fontSize: 16,
                      width: '60%',
                      height: 40,
                      textAlign: 'center',
                      marginTop: 20
                    }}
                    className="validarcodigo"
                    onClick={() => codeVer()}
                  >
                    Próximo
                  </Button>
                </div>
                <div>
                  <Button
                    className="voltar"
                    style={{
                      backgroundColor: 'var(--main-bg-D9)',
                      color: '#333333',
                      border: 'none',
                      marginTop: 16,
                      width: '39%'
                    }}
                    onClick={() => setValid(false)}
                  >
                    Voltar
                  </Button>
                </div>
              </div>
            ) : (
              <div
                className="caixa_login"
              >
                <h1 className="verificacao" style={{ marginTop: 20 }}>
                  Senha
                </h1>
                <p>Digite a nova senha!</p>
                <FormControl sx={{ m: 1, width: '100%' }} variant="outlined">
                  <InputLabel>Nova Senha</InputLabel>
                  <OutlinedInput
                    type={showPassword2 ? 'text' : 'password'}
                    value={password}
                    onChange={handleChangeSenha}
                    endAdornment={
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="toggle password visibility"
                          onClick={handleClickShowPassword2}
                          onMouseDown={handleMouseDownPassword2}
                          edge="end"
                        >
                          {showPassword2 ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                      </InputAdornment>
                    }
                    label="Nova Senha"
                  />
                </FormControl>
                <FormControl sx={{ m: 1, width: '100%' }} variant="outlined">
                  <InputLabel>Confirmar nova senha</InputLabel>
                  <OutlinedInput
                    type={showPassword3 ? 'text' : 'password'}
                    value={confirmPassword}
                    onChange={handleChangeConfirmPassword}
                    endAdornment={
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="toggle password visibility"
                          onClick={handleClickShowPassword3}
                          onMouseDown={handleMouseDownPassword3}
                          edge="end"
                        >
                          {showPassword3 ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                      </InputAdornment>
                    }
                    label="Confirmar nova senha"
                  />
                </FormControl>
                <div>
                  <Button
                    style={{
                      backgroundColor: 'var(--main-bg-D9)',
                      border: 'none',
                      color: 'var(--main-white-color)',
                      fontSize: 16,
                      width: '60%',
                      height: 40,
                      textAlign: 'center',
                      marginTop: 20
                    }}
                    value="Alterar"
                    className="validarcodigo"
                    onClick={alterar}
                  >
                    Alterar
                  </Button>
                </div>
                <div>
                  <Button
                    className="voltar"
                    style={{
                      backgroundColor: 'var(--main-bg-D9)',
                      color: '#333333',
                      border: 'none',
                      marginTop: 16,
                      width: '39%'
                    }}
                    onClick={() => setSenha(false)}
                  >
                    Voltar
                  </Button>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
      <Snackbar
        open={alerta.status}
        autoHideDuration={6000}
        onClose={handleClose}
      >
        <Alert
          onClose={handleClose}
          severity={alerta.type}
          sx={{ width: '100%' }}
        >
          {alerta.msg}
        </Alert>
      </Snackbar>
    </div>
  )
}
export default Login
